export enum UserRole {
  ADMIN = 'nriched-admin',
  DASHBOARD_USER = 'dashboard-user',
  DEMO_USER = 'demo-user',
  MARKETING_USER_2026_6 = 'marketing-2026-6',
  LEAD_USER = 'lead-user',
}

export * from './company'
export * from './survey'
export * from './iteration'
export * from './riskzone'
export * from './actionPoint'
export * from './recommendation'
export * from './distributionData'
export * from './enps'
